import { Button, TextInput, Text, ComboboxIte } from "@mantine/core";
import { useState } from "react";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { useIsOnline, usePostApi } from "src/hooks";
import { PageContainer } from "src/styled";
import { Notification } from "../../../utils/Notification";

import {
  BackupContainer,
  BackupSection,
  RestrictedMessage,
  Divider,
} from "./Backup.styled";

const Backup = () => {
  const isOnline = useIsOnline();
  const [password, setPassword] = useState("");
  const { post, isLoading: isLoadingPost } = usePostApi();

  const handleBackup = async () => {
    if (!password.trim()) {
      Notification("Error", "Please enter a password for the backup.", "red");
      return;
    }

    await post({
      request: "backup",
      body: {
        params: { pass: password },
      },
      onSuccess: response => {
        if (response?.target) {
          // Create a temporary link element for better download handling
          const link = document.createElement("a");
          link.href = response.target;
          link.download = response.target.split("/").pop();
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          Notification(
            "Success",
            "Backup has been generated and download started. Please check your Downloads folder.",
            "green",
          );
          setPassword(""); // Clear password after successful backup
        } else {
          console.error("No target URL in response:", response);
          Notification("Error", "Backup link not received from server.", "red");
        }
      },
      onError: error => {
        console.error("Backup error:", error);
        Notification(
          "Error",
          error?.message || "Failed to generate backup. Please try again.",
          "red",
        );
      },
    });
  };

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.currentTarget.value);
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleBackup();
    }
  };

  return (
    <PageContainer>
      <Breadcrumbs />

      <BackupContainer>
        {!isOnline ? (
          <RestrictedMessage>
            <Text size="lg" fw={600} mb={10}>
              Offline Mode
            </Text>
            <Text size="sm">
              Backup functionality requires an internet connection.
            </Text>
          </RestrictedMessage>
        ) : (
          <BackupSection>
            <Text size="lg" fw={600} mb={10}>
              Create Backup
            </Text>
            <Divider />
            <Text size="sm" mb={20}>
              Please set the password for the backup:
            </Text>

            <TextInput
              label="Backup Password"
              placeholder="Enter password for backup encryption"
              value={password}
              onChange={handlePasswordChange}
              onKeyPress={handleKeyPress}
              type="password"
              required
              w={"100%"}
              style={{ marginBottom: "30px" }}
            />

            <Button
              onClick={handleBackup}
              loading={isLoadingPost}
              disabled={!password.trim()}
              fullWidth>
              Generate Backup
            </Button>
          </BackupSection>
        )}
      </BackupContainer>
    </PageContainer>
  );
};

export default Backup;
